import { render, staticRenderFns } from "./AppAnnotationAssessmentReport.vue?vue&type=template&id=23c98f9e&scoped=true"
import script from "./AppAnnotationAssessmentReport.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationAssessmentReport.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationAssessmentReport.vue?vue&type=style&index=0&id=23c98f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c98f9e",
  null
  
)

export default component.exports